import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssessmentCompletionTemplate from '../components/AssessmentCompletionTemplate';
import { createPSQIAssessmentConfig } from '../config/assessmentCompletionConfigs';

interface PSQIAssessmentResult {
  id: string;
  assessmentType: 'physical';
  scores: {
    overall: number;
    categories: {
      name: string;
      score: number;
      description: string;
    }[];
    psqi: {
      componentScores: {
        sleepQuality: number;
        sleepLatency: number;
        sleepDuration: number;
        sleepEfficiency: number;
        sleepDisturbances: number;
        sleepMedication: number;
        daytimeDysfunction: number;
      };
      globalScore: number;
      sleepQuality: string;
    };
  };
  results: {
    level: 'Low' | 'Moderate' | 'High';
    interpretation: string;
    recommendations?: any[];
  };
  createdAt: string;
}

const PSQIAssessmentCompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get the assessment result from navigation state
  const assessmentResult = location.state?.assessmentResult as PSQIAssessmentResult;

  // Handle navigation in useEffect to avoid calling navigate during render
  useEffect(() => {
    if (!assessmentResult) {
      // If no result data, redirect to learn page
      navigate('/panel/learn/');
      return;
    }
  }, [assessmentResult, navigate]);

  // Don't render anything if no assessment result
  if (!assessmentResult) {
    return null;
  }

  // Create configuration using the template system
  const config = createPSQIAssessmentConfig(assessmentResult);

  // Use the template component
  return <AssessmentCompletionTemplate config={config} />;
};

export default PSQIAssessmentCompletionPage;


